import Grid from '../../../share/grid/Grid.vue'
import Page from '../../../../share/content/Page'
import RoleModal from './modal/Role.vue'
import ActionButton from '@/components/bundles/share/grid/ActionButton'

export default {
  template: `
    <div>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <grid :source="gridDataSource"
                                  :name="gridName"
                                  :columns="gridColumns"
                                  :actions="gridActions"
                                  @show="actionShow">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <role-modal :show="modalVisible"
                    @close="modalVisible = false"
                    :service="service">
        </role-modal>
    </div>`,
  components: {
    Grid,
    RoleModal
  },
  mixins: [
    Page
  ],
  data () {
    return {
      gridActions: [],
      modalVisible: false
    }
  },
  mounted () {
    this.$events.on(`${this.service}:role:addRole`, this.addRole)
  },
  computed: {
    gridDataSource () {
      const vm = this
      return { service: vm.service, url: '/roles' }
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: (data, type, row) => {
            return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
          }
        },
        { id: 1, data: 'label', title: 'Opis' },
        { id: 2, data: 'name', title: 'Nazwa' }
      ]
    }
  },
  methods: {
    addRole () {
      this.modalVisible = true
    },
    actionShow (id) {
      const vm = this
      this.$router.push({ name: vm.actionShowUrlName, params: { id } })
    }
  }
}
